// extracted by mini-css-extract-plugin
export default {"cardTable":"products-report_cardTable__LrwWm","reportTableWrapper":"products-report_reportTableWrapper__JSmh2","reportTable":"products-report_reportTable__d0tMK"};